module.exports = __webpack_public_path__ + "img/noodle-kugel.ed84e2de.jpg";